import MainScreen from './MainScreen';
import KontaktScreen from './Kontakt';
import WspolpracaScreen from './Wspolpraca';
import NotFoundScreen from './404';

export default {
	KontaktScreen,
	MainScreen,
	NotFoundScreen,
	WspolpracaScreen
};


// WEBPACK FOOTER //
// ./src/Content/Screens/index.js